import Offers from './Offers.main';

export default Offers;
